import './index.css';

export default {
  name: 'AinfiniteScroll',
  propr: {
    loading: { type: Boolean, default: () => false },
    noMore: { type: Boolean, default: () => false },
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
  },
  data() {
    return ({
      disabled: false,
    });
  },
  watch: {
    disabled() {
      return this.loading || this.noMore;
    },
  },
  methods: {
    search(a) {
      this.$emit('search', a);
    },
  },
  render() {
    const { ...attrs } = this.$attrs;
    const data = this.options || this.option || this.config || this.items || this.data || [];
    return (
      <div class="infinite-list-wrapper a-infinite-scroll">
        <ul class="list" v-infinite-scroll={this.search} infinite-scroll-disabled={this.disabled} {...{ attrs }}>
          {data.map((a, b) => (<li class="list-item" key={b}>{a.render ? a.render : a}</li>))}
        </ul>
        <p v-if={this.loading}>加载中...</p>
        <p v-if={this.noMore}>没有更多了</p>
      </div>
    );
  }
}